import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useState } from "react";
import { Button } from "../../../layout/component/Button";

export default function Travellers({
  setChildren,
  setAdults,
  adults,
  children,
}: {
  setChildren: (val: number) => void;
  setAdults: (val: number) => void;
  adults: number;
  children: number;
}) {
  const [open, setOpen] = useState(false);

  return (
    <DropdownMenu.Root open={open} onOpenChange={setOpen}>
      <DropdownMenu.Trigger className="outline-none">
        <Button className={` text-black  rounded-md px-3 py-1`}>
          Travellers
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          style={{ zIndex: 9999 }}
          sideOffset={5}
          side="top" // Position the popup at the top
          align="center" // Align it at the center of the button
          className="outline-none hover:outline-none focus:outline-none"
        >
          <DropdownMenu.Arrow className="fill-current text-white" />
          <DropdownMenu.Item
            onSelect={(event) => event.preventDefault()}
            className="outline-none hover:outline-none bg-white min-w-[300px] flex flex-col gap-3 p-2 md:p-5 py-2 shadow-xl rounded-lg text-[12px] md:text-[15px] focus:outline-none"
          >
            <div className="flex w-full flex-col md:flex-row md:items-center gap-1 md:gap-5 text-[12px] md:text-sm ">
              <p className=" w-[20%] ">Adults:</p>{" "}
              <div className=" w-[80%] flex items-center gap-2 ">
                {Array.from({ length: 9 }).map((_, index) => (
                  <div
                    className={` rounded-full hover:bg-main/80 cursor-pointer hover:text-white ${
                      Number(index) + 1 === adults
                        ? "bg-main/80 text-white "
                        : "bg-slate-500/50"
                    }  p-2 px-3 `}
                    key={index}
                    onClick={() => {
                      if (children + (index + 1) <= 9) {
                        setAdults(Number(index + 1));
                      }
                    }}
                  >
                    {" "}
                    {index + 1}{" "}
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full md:items-center gap-2 md:gap-5 text-sm ">
              <p className=" w-[20%] ">Children:</p>{" "}
              <div className=" w-[80%] flex items-center gap-2 ">
                {Array.from({ length: 9 }).map((_, index) => (
                  <div
                    className={` rounded-full hover:bg-main/80 cursor-pointer hover:text-white ${
                      Number(index) + 1 === children
                        ? "bg-main/80 text-white "
                        : "bg-slate-500/50"
                    }  p-2 px-3 `}
                    key={index}
                    onClick={() => {
                      if (adults + (index + 1) <= 9) {
                        setChildren(Number(index + 1));
                      }
                    }}
                  >
                    {" "}
                    {index + 1}{" "}
                  </div>
                ))}
              </div>
            </div>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
